function convertBoolean( obj ) {
  const newObj = {};
  const translationTable = {
    "true":  true,
    "false": false,
    "null":  null,
  }
  if ( typeof obj !== 'object' ) {
    return obj;
  }

  for ( const prop in obj ) {
    if ( !obj.hasOwnProperty( prop ) ) {
      continue;
    }
    if ( Array.isArray( obj[ prop ] ) ) {
      newObj[ prop ] = obj[ prop ].map( val => convertBoolean( val ) );
    } else {
      let attribute = translationTable[ obj[ prop ] ]
      if ( attribute !== undefined ) {
        newObj[ prop ] = attribute
      } else {
        newObj[ prop ] = convertBoolean(obj[ prop ])
      }
    }
  }
  return newObj;
}


export default convertBoolean


// WEBPACK FOOTER //
// ./src/util/convertBoolean.js